/**
 * This file provides functionality for the mobile and desktop navigation
**/

class navigation {
	/*
  * constructor
  *
  * run as soon as the JS is loaded
  *
  * This could be before the DOM is ready
  **/
	constructor() {
		//Bind this in functions that will be called in event listeners or promises
		this.domLoaded = this.domLoaded.bind(this);
		this.toggleMenu = this.toggleMenu.bind(this);
		this.fadeOutContent = this.fadeOutContent.bind(this);
		this.fadeInContent = this.fadeInContent.bind(this);
		this.expandInnerContent = this.expandInnerContent.bind(this);
		this.shrinkInnerContent = this.shrinkInnerContent.bind(this);
		this.addAccordionButton = this.addAccordionButton.bind(this);
		this.accordionToggle = this.accordionToggle.bind(this);

		//We can use this to easily tell if we have opened the menu
		this.open = false;

		//Check to see if the dom has loaded yet
		if (document.readyState === "loading") {
			//If the dom hasn't loaded, wait until it is
			document.addEventListener("readystatechange", this.domLoaded);

		} else {
			//If it has, run the domLoaded function
			this.domLoaded();
		}
	}
	/**
  * This gets run once the dom is loaded
 **/
	domLoaded() {
		//Stop it being called a second time when assets have finished loading
		document.removeEventListener("readystatechange", this.domLoaded);
		let mainNav = this.mainNav = document.querySelector('#navigation');
		//Get a reference to the opener button - This will be used to open and close the menu
		if(mainNav === null) {
			return;
		}
		let opener = this.opener = mainNav.querySelector('a.opener');
		if(opener !== null) {
			this.inner = mainNav.querySelector('.inner');
			//In the Js version of the menu, the opener does the opening and the closing of the menu
			this.removeCloser();
			//Setup the event listener for the toggle switch
			opener.addEventListener('click', this.toggleMenu);

			this.setupAccordion();
		}
	}

	/**
  * Sets up the accordion
  *
  * Adds the necesary markup and event listeners for the accordion
  **/
	setupAccordion() {
		let topul = this.mainNav.querySelector('.mega-menu-list,.mega-menu-list.flex'); // class mega-menu-list is used on Company menu.
		let lisWithChildern = [...topul.querySelectorAll('.menu-item-has-children')].filter(el => {
			if (el.classList.contains('fpl-mega-menu-column')) {  //class add in wp-admin fpl-mega-menu-column
				return false;
			}
			if (el.querySelectorAll('.sub-menu > li').length == 1) {
				return false;
			}
			return true;
		});
		lisWithChildern.forEach(this.addAccordionButton);
	}

	addAccordionButton(el) {
		let button = document.createElement('button');
		button.classList.add('opener');
		button.innerHTML = '';
		button.addEventListener('click', this.accordionToggle);
		el.insertBefore(button, el.querySelector('ul'));
	}

	accordionToggle(e) {
		let li = e.target.parentElement;
		li.classList.toggle('collapse');
	}

	/**
  * puts the close word in the opener button and removes the closer button
  *
  * In the JS version of the menu, the opener is more of a toggle switch
  **/
	removeCloser() {
		//Get references
		let opener = this.opener;
		let closer = this.mainNav.querySelector('a.closer');
		//Put the close word inside the opener and make sure is it hidden;
		if(closer !== null) {
			opener.insertBefore(closer.querySelector('.close'), opener.querySelector('.hamburger'));

			//opener.querySelector('.close').style.display = 'none';
			//Remove the closer
			closer.parentElement.removeChild(closer);
		}
	}

	/**
  * This function handles the click of the menu opener
  * Note that this refers to the class rather than the clicked element like normal event handlers
  * @param e 	the event object
 **/
	toggleMenu(e) {
		e.preventDefault();
		if (this.open) {
			this.closeMenu();
		} else {
			this.openMenu();
		}
	}

	/**
  * Opens the menu
 **/
	openMenu() {
		this.fadeOutContent().then(this.expandInnerContent).then(this.fadeInContent);
		this.mainNav.classList.add('open');
		this.open = true;
	}

	/**
  * Closes the menu
 **/
	closeMenu() {
		this.fadeOutContent().then(this.shrinkInnerContent);
		this.mainNav.classList.remove('open');
		this.open = false;
	}

	/**
  * FLIP - https://aerotwist.com/blog/flip-your-animations/?utm_campaign=chrome_serier_supercharged_061616&utm_source=chromedev&utm_medium=yt-desc
  * Works out the transform for the invert statge
 **/
	flipInvert(from, to) {
		let transform = [];
		transform.push(`translateX( ${to.left - from.left}px )`);
		transform.push(`translateY( ${to.top - from.top}px )`);
		transform.push(`scaleX( ${to.width / from.width} )`);
		transform.push(`scaleY( ${to.height / from.height} )`);
		return transform;
	}

	/*********************************************************************/
	/**                                                                 **/
	/**            Animation Part                                       **/
	/**                                                                 **/
	/*********************************************************************/

	fadeOutContent() {
		return new Promise((resolve, reject) => {
			const content = this.inner.querySelector('.menu-main-menu-container');
			if (this.open) {
				const transitionEnd = e => {
					content.removeEventListener("transitionend", transitionEnd);
					content.visibility = 'hidden';
					resolve();
				};
				content.style.transition = 'opacity .1s ease';
				content.style.opacity = 0;
				content.addEventListener("transitionend", transitionEnd);
			} else {
				content.style.opacity = 0;
				resolve();
			}
		});
	}

	fadeInContent() {
		return new Promise((resolve, reject) => {
			const content = this.inner.querySelector('.menu-main-menu-container');
			const transitionEnd = e => {
				content.removeEventListener("transitionend", transitionEnd);
				resolve();
			};
			content.style.transition = 'opacity .1s ease';
			content.style.visibility = 'visible';
			content.style.opacity = 1;
			content.addEventListener("transitionend", transitionEnd);
		});
	}

	shrinkInnerContent() {
		return new Promise((resolve, reject) => {
			const transitionEnd = e => {
				inner.removeEventListener("transitionend", transitionEnd);
				inner.style.display = 'none';
				inner.style.opacity = 1;
				resolve();
			};
			let inner = this.inner;
			inner.style.transition = '';
			let closedSize = this.opener.getBoundingClientRect();
			inner.style.display = 'block';
			let openSize = inner.getBoundingClientRect();
			inner.style.transformOrigin = '0 0';
			inner.style.transform = 'none';
			window.requestAnimationFrame(e => {
				window.requestAnimationFrame(e => {
					inner.style.transition = 'transform .2s ease-out, opacity .05s ease-out 1.5s';
					inner.style.transform = this.flipInvert(openSize, closedSize).join(' ');
					inner.style.opacity = 0;
					inner.addEventListener("transitionend", transitionEnd);
				});
			});
		});
	}

	expandInnerContent() {
		return new Promise((resolve, reject) => {
			const transitionEnd = e => {
				inner.removeEventListener("transitionend", transitionEnd);
				resolve();
			};
			let inner = this.inner;
			let initialSize = this.opener.getBoundingClientRect();
			inner.style.display = 'block';
			let finalSize = inner.getBoundingClientRect();
			inner.style.transformOrigin = '0 0';
			inner.style.transform = this.flipInvert(finalSize, initialSize).join(' ');
			window.requestAnimationFrame(e => {
				window.requestAnimationFrame(e => {
					inner.style.transition = 'transform .2s ease-out';
					inner.style.transform = 'none';
					inner.addEventListener("transitionend", transitionEnd);
				});
			});
		});
	}

}

new navigation();

